/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationAccessRecordsControllerFindAllQueryResponse, IntegrationAccessRecordsControllerFindAllQueryParams, IntegrationAccessRecordsControllerFindAll401, IntegrationAccessRecordsControllerFindAll403 } from "../../models/integrationAccessController/IntegrationAccessRecordsControllerFindAll";

function getIntegrationAccessRecordsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/integration-access-records` as const }  
  return res
}

/**
 * @summary List what Document Crunch read from integrations for the caller
 * {@link /api/v1/integration-access-records}
 */
export async function integrationAccessRecordsControllerFindAll(params?: IntegrationAccessRecordsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationAccessRecordsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessRecordsControllerFindAll401 | IntegrationAccessRecordsControllerFindAll403>, unknown>({ method : "GET", url : getIntegrationAccessRecordsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}